import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { easyCollectAPI } from "../../services/api"
import { EasyCollectResponse } from "../easy_collect";
import PaymentResponse from "../partial_payment/paymentResponse";
import SmartPayError from "../error"
import { HeaderComponent } from "../../shared_components";
import { Card, Skeleton } from "antd";

const isMobile = window.innerWidth <= 810;

const EasyCollectCardComponent = (props) => {
    const { isLoading, CoverComponent } = props
    return (
        <div className={isMobile ? "mobile-main-section" : "main-section"}>
            <Card variant="borderless" cover={<CoverComponent />} className={isMobile ? "mobile-wrapper" : "easycollect-card"}>
                <Skeleton loading={isLoading} paragraph={{ rows: 20 }}>
                    {props.children}
                </Skeleton>
            </Card>
        </div>
    )
}

const BaseResponseWrapper = () => {
    const { url, txn_id } = useParams();
    const [responseData, setResponseData] = useState({})
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => getLinkDetails(), [])

    const getLinkDetails = async () => {
        setIsLoading(true);
        await easyCollectAPI.get_txn_details(url, txn_id)
            .then((response) => {
                if (Object.keys(response).length > 0)
                    setResponseData(response)
                else
                    setResponseData({})
            })
            .catch(() => setResponseData({}))
            .finally(() => setIsLoading(false))
    }

    if (isLoading)
        return <EasyCollectCardComponent isLoading={isLoading} CoverComponent={() => <HeaderComponent logo={''} name={''} />} />
    let payment_type = responseData?.data?.payment_type
    let mappedComponents = { 'SP': EasyCollectResponse, "PP": PaymentResponse }
    if (payment_type && Object.keys(mappedComponents).includes(payment_type)) {
        let FinalComponent = mappedComponents[payment_type]
        return <FinalComponent propsLinkData={responseData} />
    }
    let error_message = responseData?.error || responseData?.error_msg
    if (error_message)
        return <SmartPayError title={error_message} errorMsg="Please contact Easebuzz Suport."/>
    return <SmartPayError/> 
}

export default BaseResponseWrapper